import { CommonPageTWCard } from '@lemon8/web-app-shared/ssr';
import { useActivityTDK } from './use-activity-tdk';
import { useAtomValue } from 'jotai';
import { ImageRegion } from '../constants';
import { $Locale } from '@lemon8/web-app-shared/atom';

export const ActivityTwitter = () => {
  const { region } = useAtomValue($Locale);
  const { title, description } = useActivityTDK();
  const image = ImageRegion[region] || ImageRegion.default;

  const twitterCardInfo = {
    twCardTitle: title,
    twCardDesc: description,
    twCardImageSrc: image,
  };

  return <CommonPageTWCard {...twitterCardInfo} />;
};
